











import Vue from 'vue';

export default Vue.extend({
  props: {
    left: { type: Boolean, default: false },
    bottom: { type: Boolean, default: false },
    color: { type: String, default: 'base' },
    overlap: { type: Boolean, default: false },
    spacious: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
  },
  computed: {
    classList() {
      return {
        'p-badge-badge': true,
        [`color-${this.color}`]: this.color,
        top: !this.bottom,
        bottom: this.bottom,
        right: !this.left,
        left: this.left,
        overlap: this.overlap,
        spacious: this.spacious,
        dense: this.dense,
      };
    },
  },
});
